import "core-js/modules/es.symbol";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.keys";
import "core-js/modules/web.dom-collections.for-each";

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? Object(arguments[i]) : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import * as React from 'react';
import classNames from 'classnames';
import DataTableContext, { defaultDataTableContextProps } from "./DataTableContext";
import { Table } from "../Table";

var DataTable = function DataTable(props) {
  var _defaultDataTableCont = _objectSpread({}, defaultDataTableContextProps, props),
      children = _defaultDataTableCont.children,
      className = _defaultDataTableCont.className,
      _defaultDataTableCont2 = _defaultDataTableCont.hideLastDivider,
      hideLastDivider = _defaultDataTableCont2 === void 0 ? true : _defaultDataTableCont2,
      _defaultDataTableCont3 = _defaultDataTableCont.size,
      size = _defaultDataTableCont3 === void 0 ? 'medium' : _defaultDataTableCont3;

  var classes = classNames('DataTable', {
    'DataTable--hideLastDivider': hideLastDivider,
    'DataTable--size--medium': size === 'medium',
    'DataTable--size--small': size === 'small'
  }, className);
  var value = React.useMemo(function () {
    return {
      size: size
    };
  }, [size]);
  return /*#__PURE__*/React.createElement(DataTableContext.Provider, {
    value: value
  }, /*#__PURE__*/React.createElement(Table, {
    className: classes
  }, children));
};

export default DataTable;